<template><section><div class="card" style="margin:0;width:300px;text-align:left">
  <div class="van-doc-intro">
    <img class="van-doc-intro__logo" style="width: 120px; height: 120px;" src="https://img.yzcdn.cn/vant/logo.png">
  </div>
</div>
<h4>Vant 企业端常用组件</h4>
<h5>card3 弹出框 组件</h5>
<pre v-pre><code v-pre>&lt;template&gt;
      &lt;div&gt;
        &lt;demo-block title='商品审核'&gt;
          &lt;van-button type=&quot;primary&quot; block @click='show_shenhe = true'&gt;商品审核（向上弹出）&lt;/van-button&gt;
          &lt;van-popup
            v-model=&quot;show_shenhe&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
              &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
               商品审核
              &lt;/van-divider&gt;
              &lt;van-cell title=&quot;适用机柜&quot; value=&quot;称重柜&quot; /&gt;
              &lt;van-checkbox-group v-model=&quot;result_machine&quot;&gt;
                  &lt;van-cell-group&gt;
                    &lt;van-cell
                      v-for=&quot;(item,index) in machine_list&quot;
                      clickable
                      :key=&quot;index&quot;
                      :title='item'
                    &gt;
                      &lt;van-checkbox
                        :name=&quot;item&quot;
                        ref=&quot;checkboxes&quot;
                        slot=&quot;right-icon&quot;
                      /&gt;
                    &lt;/van-cell&gt;
                  &lt;/van-cell-group&gt;
                &lt;/van-checkbox-group&gt;
                 &lt;van-cell is-link title=&quot;商品分类&quot; @click=&quot;value_down1 = true&quot; :value='cellValue' /&gt;
                 &lt;van-cell is-link title=&quot;商品重量&quot; @click=&quot;value_down1 = true&quot; :value='cellValue1' /&gt;
                &lt;van-action-sheet v-model=&quot;value_down1&quot; :actions=&quot;option1&quot; @select=&quot;onSelect&quot; /&gt;
                &lt;!-- &lt;van-action-sheet v-model=&quot;show&quot; :actions=&quot;actions&quot; @select=&quot;onSelect&quot; /&gt; --&gt;
              &lt;/div&gt;
          &lt;/van-popup&gt;
        &lt;/demo-block&gt;
         &lt;div style=&quot;height:20px;&quot;&gt;&lt;/div&gt;
         &lt;demo-block title=&quot;创建工单&quot;&gt;
          &lt;van-button type=&quot;primary&quot; block @click='show_worksheet = true'&gt;创建工单（向上弹出）&lt;/van-button&gt;
          &lt;!-- 创建工单 --&gt;
          &lt;van-popup
            v-model=&quot;show_worksheet&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
              &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
              创建工单
              &lt;/van-divider&gt;
              &lt;div class='orderno'&gt;订单编号：BB06829122482592&lt;/div&gt;
                &lt;van-collapse v-model=&quot;activeNames_type&quot;&gt;
                  &lt;van-collapse-item title=&quot;请输入问题类型&quot; name=&quot;1&quot;&gt;
                      &lt;!-- 单选 --&gt;
                      &lt;van-radio-group v-model=&quot;radio&quot;&gt;
                        &lt;van-cell-group&gt;
                          &lt;van-cell title=&quot;金额错误&quot; clickable @click=&quot;radio = '1'&quot;&gt;
                            &lt;van-radio slot=&quot;right-icon&quot; name=&quot;1&quot; /&gt;
                          &lt;/van-cell&gt;
                          &lt;van-cell title=&quot;识别错误&quot; clickable @click=&quot;radio = '2'&quot;&gt;
                            &lt;van-radio slot=&quot;right-icon&quot; name=&quot;2&quot; /&gt;
                          &lt;/van-cell&gt;
                          &lt;van-cell title=&quot;包装问题&quot; clickable @click=&quot;radio = '3'&quot;&gt;
                            &lt;van-radio slot=&quot;right-icon&quot; name=&quot;3&quot; /&gt;
                          &lt;/van-cell&gt;
                        &lt;van-cell title=&quot;过保质期&quot; clickable @click=&quot;radio = '4'&quot;&gt;
                            &lt;van-radio slot=&quot;right-icon&quot; name=&quot;4&quot; /&gt;
                          &lt;/van-cell&gt;
                        &lt;van-cell title=&quot;其他&quot; clickable @click=&quot;radio = '5'&quot;&gt;
                            &lt;van-radio slot=&quot;right-icon&quot; name=&quot;5&quot; /&gt;
                          &lt;/van-cell&gt;
                        &lt;/van-cell-group&gt;
                      &lt;/van-radio-group&gt;
                      &lt;!-- 单选 --&gt;
                  &lt;/van-collapse-item&gt;
                &lt;/van-collapse&gt;
                &lt;van-field
                  v-model=&quot;message&quot;
                  rows=&quot;2&quot;
                  autosize
                  label=&quot;留言&quot;
                  type=&quot;textarea&quot;
                  maxlength=&quot;50&quot;
                  placeholder=&quot;请输入留言&quot;
                  show-word-limit
                /&gt;
                &lt;van-divider&gt;相关图片(0/{{fileList.length}})&lt;/van-divider&gt;
                &lt;div style=&quot;margin:0 0 0 5px&quot;&gt;
                  &lt;van-uploader
                  v-model=&quot;fileList&quot;
                  multiple
                  :max-count=&quot;4&quot;
                  /&gt;
                &lt;/div&gt;
                &lt;div class=&quot;w_footer&quot;&gt;
                  &lt;van-button type=&quot;default&quot; @click='show_worksheet=false'&gt;取消&lt;/van-button&gt;
                  &lt;van-button type=&quot;primary&quot;&gt;确定&lt;/van-button&gt;
                &lt;/div&gt;
              &lt;/div&gt;
          &lt;/van-popup&gt;
          &lt;!-- 创建工单 --&gt;
        &lt;/demo-block&gt;
        &lt;div style=&quot;height:20px;&quot;&gt;&lt;/div&gt;
         &lt;demo-block title=&quot;客服工单&quot;&gt;
          &lt;van-button type=&quot;primary&quot; block @click='show_worksheet_kf = true'&gt;客服工单（向上弹出）&lt;/van-button&gt;
          &lt;!-- 创建工单 --&gt;
          &lt;van-popup
            v-model=&quot;show_worksheet_kf&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '60%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
              &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
              客服工单处理
              &lt;/van-divider&gt;
                &lt;van-collapse v-model=&quot;activeNames_type&quot;&gt;
                  &lt;van-collapse-item name=&quot;1&quot;&gt;
                     &lt;div slot=&quot;title&quot;&gt;处理方案&lt;span class=&quot;detitle&quot;&gt;{{orderArr[radio].desc}}&lt;/span&gt;&lt;/div&gt;
                      &lt;!-- 单选 --&gt;
                      &lt;van-radio-group v-model=&quot;radio&quot;&gt;
                        &lt;van-cell-group&gt;
                          &lt;van-cell v-for='(item,index) in orderArr' :key='index' :title=&quot;item.desc&quot; clickable @click=&quot;clickFn(index)&quot;&gt;
                            &lt;van-radio slot=&quot;right-icon&quot;  :name=&quot;index&quot; /&gt;
                          &lt;/van-cell&gt;
                        &lt;/van-cell-group&gt;
                      &lt;/van-radio-group&gt;
                      &lt;!-- 单选 --&gt;
                  &lt;/van-collapse-item&gt;
                &lt;/van-collapse&gt;
                &lt;van-cell :value=&quot;orderArr[radio].intro&quot; /&gt;
                &lt;div class=&quot;w_footer&quot;&gt;
                  &lt;van-button type=&quot;default&quot; @click='show_worksheet_kf=false'&gt;取消&lt;/van-button&gt;
                  &lt;van-button type=&quot;primary&quot; @click='setpFn()'&gt;下一步&lt;/van-button&gt;
                &lt;/div&gt;
              &lt;/div&gt;
          &lt;/van-popup&gt;
          &lt;!-- 创建工单 --&gt;
        &lt;/demo-block&gt;
        &lt;div style=&quot;height:20px;&quot;&gt;&lt;/div&gt;
         &lt;demo-block title=&quot;商品调整&quot;&gt;
          &lt;van-button type=&quot;primary&quot; block @click='treatplanid_16 = true'&gt;商品调整（向上弹出）&lt;/van-button&gt;
          &lt;!-- 创建工单 --&gt;
          &lt;van-popup
            v-model=&quot;treatplanid_16&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                 &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                  客服工单处理(商品调整)
                 &lt;/van-divider&gt;
                 &lt;/div&gt;
                 
                 &lt;div style=&quot;float:right;padding:10px 10px&quot;&gt;&lt;van-button type=&quot;primary&quot; size=&quot;small&quot; @click='addGoods'&gt;添加商品&lt;/van-button&gt;&lt;/div&gt;
                 &lt;div style=&quot;clear:both&quot;&gt;&lt;/div&gt;
                 &lt;div&gt;
                  &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                    &lt;div slot=&quot;title&quot;&gt;
                          &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                          &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                            &lt;ul class=&quot;goodInfo&quot;&gt;
                              &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                              &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                              &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                            &lt;/ul&gt;
                    &lt;/div&gt;
                  &lt;/van-card&gt;
                  &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                    &lt;div slot=&quot;title&quot;&gt;
                          &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                          &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                            &lt;ul class=&quot;goodInfo&quot;&gt;
                              &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                              &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                              &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                            &lt;/ul&gt;
                    &lt;/div&gt;
                  &lt;/van-card&gt;
                  &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                    &lt;div slot=&quot;title&quot;&gt;
                          &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                          &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                            &lt;ul class=&quot;goodInfo&quot;&gt;
                              &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                              &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                              &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                            &lt;/ul&gt;
                    &lt;/div&gt;
                  &lt;/van-card&gt;
                  &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                    &lt;div slot=&quot;title&quot;&gt;
                          &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                          &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                            &lt;ul class=&quot;goodInfo&quot;&gt;
                              &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                              &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                              &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                            &lt;/ul&gt;
                    &lt;/div&gt;
                  &lt;/van-card&gt;
                  &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                    &lt;div slot=&quot;title&quot;&gt;
                          &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                          &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                            &lt;ul class=&quot;goodInfo&quot;&gt;
                              &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                              &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                              &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                            &lt;/ul&gt;
                    &lt;/div&gt;
                  &lt;/van-card&gt;
                  &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                    &lt;div slot=&quot;title&quot;&gt;
                          &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                          &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                            &lt;ul class=&quot;goodInfo&quot;&gt;
                              &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                              &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                              &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                            &lt;/ul&gt;
                    &lt;/div&gt;
                  &lt;/van-card&gt;
                 &lt;/div&gt;
                 &lt;div class='countDiv'&gt;
                   &lt;div class='countInfo'&gt;原商品数量：2.00，原订单总金额：￥10.00&lt;/div&gt;
                    &lt;div class=&quot;w_footer&quot;&gt;
                      &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                      &lt;van-button type=&quot;primary&quot; @click=&quot;addGoodsBoolean_s = true&quot;&gt;下一步&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
          &lt;/van-popup&gt;
         &lt;/demo-block&gt;
         &lt;div style=&quot;height:20px;&quot;&gt;&lt;/div&gt;
         &lt;demo-block&gt;
          &lt;van-popup
            v-model=&quot;addGoodsBoolean&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ width:'100%',height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:30px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                 &lt;van-search
                      v-model=&quot;searchGoods&quot;
                      placeholder=&quot;请输入搜索关键词&quot;
                      input-align=&quot;center&quot;
                    /&gt;
                 &lt;/div&gt;
                 &lt;van-tabs v-model=&quot;active&quot;&gt;
                    &lt;van-tab title=&quot;当前已规划商品&quot;&gt;
                        &lt;div&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                        &lt;/div&gt;
                    &lt;/van-tab&gt;
                    &lt;van-tab title=&quot;商户商品库商品&quot;&gt;
                        &lt;div&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;添加&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;添加&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;添加&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;添加&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class=&quot;remove&quot;&gt;删除&lt;/div&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                        &lt;/div&gt;
                    &lt;/van-tab&gt;
                  &lt;/van-tabs&gt;
                 &lt;div class='countDiv_s'&gt;
                    &lt;div class=&quot;w_footer_s&quot;&gt;
                      &lt;van-button type=&quot;primary&quot;&gt;返回&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
          &lt;/van-popup&gt;

         &lt;/demo-block&gt;
         &lt;div style=&quot;height:20px;&quot;&gt;&lt;/div&gt;
          &lt;demo-block&gt;
          &lt;van-popup
            v-model=&quot;addGoodsBoolean_s&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ width:'100%',height: '100%' }&quot;&gt;
              &lt;div style=&quot;padding:30px 0 60px 0&quot;&gt;
                 &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                  客服工单处理(商品调整)
                 &lt;/van-divider&gt;
                 &lt;van-divider content-position=&quot;left&quot;&gt;商品调整确认&lt;/van-divider&gt;
                 &lt;div&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                          &lt;van-card :thumb=&quot;imageURL&quot;&gt;
                            &lt;div slot=&quot;title&quot;&gt;
                                  
                                  &lt;div class='new_detail_goods'&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;span&gt;(200kg/盒)&lt;/span&gt;&lt;/div&gt;
                                    &lt;ul class=&quot;goodInfo&quot;&gt;
                                      &lt;li&gt;&lt;span&gt;售价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                                      &lt;li&gt;&lt;span&gt;小计：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                                      &lt;li style=&quot;margin-top:5px&quot;&gt;&lt;span style=&quot;float:left&quot;&gt;实际数量：&lt;/span&gt;&lt;span style=&quot;float:left&quot;&gt;&lt;van-stepper v-model=&quot;realValue&quot; disabled-input/&gt;&lt;/span&gt;&lt;/li&gt;
                                    &lt;/ul&gt;
                            &lt;/div&gt;
                          &lt;/van-card&gt;
                        &lt;/div&gt;
                 &lt;div class='countDiv_s' style=&quot;height:220px&quot;&gt;
                   &lt;div class='countInfo_goods'&gt;原订单金额¥212，调整后订单金额¥239。 顾客已支付人民¥0。&lt;/div&gt;
                   &lt;div class='countInfo_goods'&gt;点击“确定”按钮，将生成商品调整单且订单状态将变更为“已欠费”。是否继续？&lt;/div&gt;
                   &lt;van-field
                      v-model=&quot;message_goods&quot;
                      rows=&quot;2&quot;
                      autosize
                      label=&quot;留言&quot;
                      type=&quot;textarea&quot;
                      maxlength=&quot;50&quot;
                      placeholder=&quot;请输入留言&quot;
                      show-word-limit
                    /&gt;
                    &lt;div class=&quot;w_footer&quot;&gt;
                        &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                        &lt;van-button type=&quot;primary&quot; @click=&quot;finishFn()&quot;&gt;确定&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
          &lt;/van-popup&gt;
         &lt;/demo-block&gt;
         &lt;!-- 退款 --&gt;
           &lt;van-popup
            v-model=&quot;treatplanid_15&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                    &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                      客服工单处理(退款)
                    &lt;/van-divider&gt;
                    &lt;van-divider content-position=&quot;left&quot;&gt;工单处理方案：发起退款&lt;/van-divider&gt;
                      &lt;!-- 允许输入数字，调起全键盘 --&gt;
                      &lt;van-cell-group&gt;
                        &lt;van-field v-model=&quot;tk_number&quot; type=&quot;number&quot; label=&quot;退款金额&quot; placeholder=&quot;请输入退款金额&quot;  /&gt;
                      &lt;/van-cell-group&gt;
                      &lt;div class='validDiv'&gt;（最多可退¥200，通过此工单已退¥0）&lt;/div&gt;
                      &lt;van-field
                          v-model=&quot;message_tk&quot;
                          rows=&quot;2&quot;
                          autosize
                          label=&quot;解决备注&quot;
                          type=&quot;textarea&quot;
                          maxlength=&quot;50&quot;
                          placeholder=&quot;请输入备注&quot;
                          show-word-limit
                        /&gt;
                      &lt;van-divider /&gt;
                      &lt;div class=&quot;w_footer&quot;&gt;
                        &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                        &lt;van-button type=&quot;primary&quot; @click=&quot;show_tk = true&quot;&gt;确定&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-popup&gt;
         &lt;!-- 退款提示框 --&gt;
          &lt;van-dialog v-model=&quot;show_tk&quot; title=&quot;提示&quot;&gt;
            &lt;div class='tk_Info'&gt;应退款金额¥100，已退款成功¥50，
            稍候请通过此工单继续发起退款！&lt;/div&gt;
          &lt;/van-dialog&gt;
        &lt;!-- 追缴 --&gt;
         &lt;van-popup
            v-model=&quot;treatplanid_12&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                    &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                      客服工单处理(追缴)
                    &lt;/van-divider&gt;
                    &lt;van-divider content-position=&quot;left&quot;&gt;工单处理方案：发起追缴&lt;/van-divider&gt;
                    &lt;div class='validDiv11'&gt;订单金额¥200，已支付金额¥50。&lt;/div&gt;
                      &lt;!-- 允许输入数字，调起全键盘 --&gt;
                      &lt;van-cell-group&gt;
                        &lt;van-field v-model=&quot;tk_number&quot; type=&quot;number&quot; label=&quot;补交金额：&quot; placeholder=&quot;请确认补缴金额&quot;  /&gt;
                      &lt;/van-cell-group&gt;
                      &lt;div class='validDiv'&gt;（通过此工单已追缴¥0）&lt;/div&gt;
                      &lt;van-field
                          v-model=&quot;message_tk&quot;
                          rows=&quot;2&quot;
                          autosize
                          label=&quot;解决备注&quot;
                          type=&quot;textarea&quot;
                          maxlength=&quot;50&quot;
                          placeholder=&quot;请输入备注&quot;
                          show-word-limit
                        /&gt;
                      &lt;van-divider /&gt;
                      &lt;div class=&quot;w_footer&quot;&gt;
                        &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                        &lt;van-button type=&quot;primary&quot; @click=&quot;show_tk = true&quot;&gt;确定&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-popup&gt;
        &lt;!-- 工单关闭 --&gt;
         &lt;van-popup
            v-model=&quot;treatplanid_18&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                    &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                      客服工单处理(关闭工单)
                    &lt;/van-divider&gt;
                    &lt;van-divider content-position=&quot;left&quot;&gt;工单处理方案：关闭工单&lt;/van-divider&gt;
                    &lt;div class='validDiv_yc'&gt;点击“确定”按钮，订单状态将变更为“已完成”。&lt;/div&gt;
                    &lt;div class='validDiv_yc'&gt;是否继续？&lt;/div&gt;
                      &lt;van-field
                          v-model=&quot;message_tk&quot;
                          rows=&quot;2&quot;
                          autosize
                          label=&quot;解决备注&quot;
                          type=&quot;textarea&quot;
                          maxlength=&quot;50&quot;
                          placeholder=&quot;请输入备注&quot;
                          show-word-limit
                        /&gt;
                      &lt;van-divider /&gt;
                      &lt;div class=&quot;w_footer&quot;&gt;
                        &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                        &lt;van-button type=&quot;primary&quot; @click=&quot;show_tk = true&quot;&gt;确定&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-popup&gt;
        &lt;!-- 购物流程已结束 --&gt;
          &lt;van-popup
            v-model=&quot;treatplanid_17&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                    &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                      客服工单处理(购物流程已结束)
                    &lt;/van-divider&gt;
                    &lt;van-divider content-position=&quot;left&quot;&gt;工单处理方案：购物流程已结束&lt;/van-divider&gt;
                    &lt;div class='validDiv_yc'&gt;点击“确定”按钮，订单状态将变更为“已完成”。&lt;/div&gt;
                    &lt;div class='validDiv_yc'&gt;是否继续？&lt;/div&gt;
                      &lt;van-field
                          v-model=&quot;message_tk&quot;
                          rows=&quot;2&quot;
                          autosize
                          label=&quot;解决备注&quot;
                          type=&quot;textarea&quot;
                          maxlength=&quot;50&quot;
                          placeholder=&quot;请输入备注&quot;
                          show-word-limit
                        /&gt;
                      &lt;van-divider /&gt;
                      &lt;div class=&quot;w_footer&quot;&gt;
                        &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                        &lt;van-button type=&quot;primary&quot; @click=&quot;show_tk = true&quot;&gt;确定&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-popup&gt;
      
      
        &lt;!-- 异常订单放弃处理 --&gt;
        &lt;van-popup
            v-model=&quot;treatplanid_14&quot;
            closeable
            close-icon=&quot;close&quot;
            position=&quot;bottom&quot;
            :style=&quot;{ height: '80%' }&quot;&gt;
              &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
                 &lt;div&gt;
                    &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
                      客服工单处理(异常订单放弃处理)
                    &lt;/van-divider&gt;
                    &lt;van-divider content-position=&quot;left&quot;&gt;工单处理方案：异常订单放弃处理&lt;/van-divider&gt;
                    &lt;div class='validDiv_yc'&gt;原订单金额¥100，顾客已支付¥0。&lt;/div&gt;
                    &lt;div class='validDiv_yc'&gt;点击“确定”按钮，订单状态将变更为“已欠费”。&lt;/div&gt;
                    &lt;div class='validDiv_yc'&gt;是否继续？&lt;/div&gt;
                      
                      &lt;van-field
                          v-model=&quot;message_tk&quot;
                          rows=&quot;2&quot;
                          autosize
                          label=&quot;解决备注&quot;
                          type=&quot;textarea&quot;
                          maxlength=&quot;50&quot;
                          placeholder=&quot;请输入备注&quot;
                          show-word-limit
                        /&gt;
                      &lt;van-divider /&gt;
                      &lt;div class=&quot;w_footer&quot;&gt;
                        &lt;van-button type=&quot;default&quot;&gt;上一步&lt;/van-button&gt;
                        &lt;van-button type=&quot;primary&quot; @click=&quot;show_tk = true&quot;&gt;确定&lt;/van-button&gt;
                    &lt;/div&gt;
                 &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-popup&gt;
      
      &lt;/div&gt;
&lt;/template&gt;

</code></pre>
<template>
        <div class="main">
      <div class="cardDiv">
        <el-scrollbar style="height:100%">
           <iframe src="http://localhost:8080/card3" height="700px" width="360px" frameborder="0"></iframe>
         </el-scrollbar>
           </div>
      </div>
</template>


</section></template>
<style lang="less">
  .main{
    border:1px solid red;
    
    height:100%;
    
  
  
  }
.cardDiv{
    position: absolute;
    z-index: 1;
    box-sizing: border-box;
    width: 360px;
    min-width: 360px;
    background: #fafafa;
    border-radius: 12px;
    box-shadow: #a3a4a5 0 4px 12px;
    min-height:700px;
    right:30px;
    top:20px;
    
    
}
// 创建工单
.w_footer{
  position:fixed;
  width:100%;
  bottom:10px;
  text-align: center;
}

.w_footer button{
  width:45%;
  margin:0 5px;

}
.w_footer_s{
  position: absolute;
  width:100%;
  bottom:10px;
  text-align: center;
}
.w_footer_s button{
  width:90%;
  margin:auto;

}
.remove{
  color:red;
  margin-left:50px;
}

.countDiv{
  position:fixed;
  width:100%;
  bottom:0;
  padding:20px 0;
  background:#fff;
  height:80px;
}
.countDiv_s{
  position:fixed;
  width:100%;
  bottom:0;
  padding:20px 0;
  background:#fff;
  height:40px;
}
.countInfo{
  text-align:center;
}

.countInfo_goods{
  font-size: 14px;
  text-align: left;
  padding: 5px 20px;
}
.countInfo_goods_r{
  font-size: 14px;
  text-align: left;
  color:red;
  padding: 5px 20px;
}
.validDiv{
  color:red;
  font-size:14px;
   padding:20px;
}
.validDiv11{
  color:#000;
  font-size:14px;
  padding:20px;
}
.validDiv_yc{
  color:#000;
  font-size:14px;
  padding:5px 15px;
}

.tk_Info{
  font-size:12px;
  padding:20px;
}

</style>
<script>
export default {
  i18n: {
    'zh-CN': {
      errorInfo: '错误提示',
      errorText: '请求失败，点击重新加载',
      pullRefresh: '下拉刷新',
      finishedText: '没有更多了',
    },
    'en-US': {
      errorInfo: 'Error Info',
      errorText: 'Request failed. Click to reload',
      pullRefresh: 'PullRefresh',
      finishedText: 'Finished',
    },
  },

  data() {
    return {
      cellValue:'',
      value_down1: false,
      option1: [
        { name: '选项1' },
        { name: '选项2' },
        { name: '选项3', subname: '描述信息' }
      ],
      result_machine:["重力柜",'视觉柜','RFID柜','重力视觉柜'],
      machine_list:["重力柜",'视觉柜','RFID柜','重力视觉柜'],
      show_shenhe:false,
      show_tk:false,
      message_tk:'',
      tk_number:'',
      message_goods:'',
      list:[],
      finished:false,
      loading:false,
      active:0,
      active_goods:0,
      searchGoods:'',
      addGoodsBoolean:false,
      addGoodsBoolean_s:false,
      realValue:0,
      imageURL: 'https://img.yzcdn.cn/vant/ipad.jpeg',
      show_worksheet:false,
      show_worksheet_kf:false,
      activeNames_type:['0'],
      radio:0,
      message:'',
      fileList:[],
      orderArr:[
        {
        "treatplanid": "16",
        "desc": "调整订单商品信息",
        "intro": "在人工通过购物视频或其他方式确认顾客所拿商品与订单中商品不一致的情况下，可对订单商品明细进行调整，调整后会根据结果修改订单金额及订单状态。"
        },
        {
        "treatplanid": "15",
        "desc": "发起退款",
        "intro": "发起退款发起退款发起退款发起退款"
        },
        {
        "treatplanid": "12",
        "desc": "发起追缴",
        "intro": "发起追缴：对订单进行追缴，根据支付方式优先级进行扣费，追缴失败或部分成功不修改订单状态，追缴全部成功将修改订单状态为\"已付款\"。"
        },
         {
        "treatplanid": "14",
        "desc": "异常订单放弃处理",
        "intro": "异常订单放弃处理异常订单放弃处理异常订单放弃处理异常订单放弃处理异常订单放弃处理异常订单放弃处理异常订单放弃处理"
        },
         {
        "treatplanid": "17",
        "desc": "购物流程已结束",
        "intro": "购物流程已结束购物流程已结束购物流程已结束购物流程已结束购物流程已结束购物流程已结束购物流程已结束购物流程已结束"
        },
         {
        "treatplanid": "18",
        "desc": "关闭工单",
        "intro": "关闭工单关闭工单关闭工单关闭工单关闭工单关闭工单"
        }
         
      ],
      treatplanid_16:false,
      treatplanid_15:false,
      treatplanid_12:false,
      treatplanid_14:false,
      treatplanid_17:false,
      treatplanid_18:false,
    };
  },

  methods: {
    onSelect(item){
      this.value_down1 = false;
      this.cellValue = item.name;
      this.$toast(item.name);
    },
    finishFn15(){
      this.$toast('退款成功');
    },
    finishFn(){
      this.$toast('订单已欠费，已自动生成追缴工单');
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
  
    addGoods(){
       this.addGoodsBoolean = true;
    },
    setpFn(){
      //alert(this.orderArr[this.radio].treatplanid)
      let treatplanid = this.orderArr[this.radio].treatplanid;
      if(treatplanid == 16){
        this.treatplanid_16 = true;
        return
      }
       if(treatplanid == 15){
        this.treatplanid_15 = true;
        return
      }
      if(treatplanid == 12){
        this.treatplanid_12 = true;
        return
      }
      if(treatplanid == 14){
        this.treatplanid_14 = true;
        return
      }
       if(treatplanid == 17){
        this.treatplanid_17 = true;
        return
      }
      if(treatplanid == 18){
        this.treatplanid_18 = true;
        return
      }

    },
    clickFn(index){
      var that = this;
      this.radio = index;
      setTimeout(function(){
        that.activeNames_type = ['0']
      },150)
      
    }
  }
};
</script>